import React from 'react';
import styled from 'styled-components';
import { MaterialIcon, Button } from '@pearsontechnology/aero-components';

export const Card = styled.div`
  box-sizing: border-box;
  box-shadow: ${(props) => props.theme['shadow.card']};
  background-color: ${(props) => props.theme['color.surface']};
  color: ${(props) => props.theme['color.text.body']};
  height: 650px;
  margin: 1% auto;
  width: 98%;
  transition: opacity 1s ease 1s;
  padding: 30px;
  position: relative;
`;

export const CloseWrapper = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  justify-content: end;
  
  & button {
    position: absolute;
    top: 0;
    right: 0px;
  }
`;

export const CardHearder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 2px solid #ccc;
`;

export const CardHeaderItem = styled.div`
  flex-shrink: 0;
  word-wrap: break-word;

  & a {
    text-decoration: none;
    color: black;
  }
`;

export const TableHeaderItems = styled.div`
  display: flex;
  align-items: center;
`;

export const Version = styled.div`
  font-weight: bold;
  font-size: 18px
`;

export const ReleaseDate = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
`;

export const SaveButton = styled.button`
  color: ${(props) => props.theme['color.text.body']}
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
`;

export const CardContentWrapper = styled.div`
  height: 500px;
  overflow-y: auto;

  &svg {
    margin-top: 100px;
  }
`;
export const VersionCompareTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  & thead {
    border-bottom: 1px solid #ccc;
  }
`;

export const TableHeader = styled.th`
  padding: 15px;
  text-align: left;
`;

export const TableRow = styled.tr`
  padding: 10px;
  border-bottom: 1px solid #ccc;
`;

export const TableData = styled.td.attrs((props) => ({
  colSpan: props.colSpan,
}))`
  padding: 15px;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }

  ${(props) =>
    props.textAlign &&
    `
      text-align: ${props.textAlign};
    `}
`;

export const SortButton = styled(
  ({ id, sort, ...rest }) => (
    <GreyButton iconName={sort === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'} {...rest} />
  ),
)`
  margin-left: 5px;
  display: flex;
`;


export const GreyButton = ({ iconName, ...rest }) => (
  <Button iconOnly grey height={34} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
);